import React from 'react'
import axios from '~/data/http/axios'
import * as user from '~/data/actions/userActions' //now we can use user actions here
import { connect } from 'react-redux'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import DropDown from '~/Common-Objects/UI/DropDowns/DropDown'
import Icons from '~/Common-Objects/UI/Icons/index'
import PermissionChecker from '../../../../../Classes/permissions'
import i18n from '~/i18n'
import CompanySelect from '../bb_topNav_CompanySelect'
import VideoModal from '~/Common-Objects/VideoModal'
import onboardingPoster from '~/assets/images/setup/video-poster-large.png'
import { alterFullpage } from '~/data/actions/siteActions'
import { isMailchimpImportBeta } from '~/utils/mailchimpImportBeta'
import moment from 'moment'
@connect((store) => {
    return {
        user: store.user,
        browser: store.browser,
        accountMaster: store.accountMaster,
        permissionStore: store.permission,
        siteMaster: store.siteMaster
    }
})
export default class bb_account extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            navOpen: false,
            accounts: [],
            loadedAccounts: false,
            accountDetails: {},
            companySwitcherOpen: false,
            hasMailchimp: false
        }

        this.companySwitcherLeaveTimerRef = React.createRef(null)

        this.goLog = this.goLog.bind(this)
        this.navClicked = this.navClicked.bind(this)
        this.goNav = this.goNav.bind(this)
        this.hasPermission = this.hasPermission.bind(this)
        this.goOpen = this.goOpen.bind(this)
        this.goGetStarted = this.handleClickGetStarted.bind(this)
        this.loadMailchimp = this.loadMailchimp.bind(this)
    }

    componentDidMount() {
        this.loadMailchimp()
    }

    componentDidUpdate(prevProps) {
        const prevId =
            prevProps.accountMaster && prevProps.accountMaster.accountMaster && prevProps.accountMaster.accountMaster.id
        const nextId =
            this.props.accountMaster &&
            this.props.accountMaster.accountMaster &&
            this.props.accountMaster.accountMaster.id
        const prevPermissions = prevProps.permissionStore && prevProps.permissionStore.permissions
        const nextPermissions = this.props.permissionStore && this.props.permissionStore.permissions
        if (prevId !== nextId || prevPermissions !== nextPermissions) this.loadMailchimp()
    }

    loadMailchimp() {
        if (!this.hasPermission('company', 'write')) {
            if (this.state.hasMailchimp) this.setState({ hasMailchimp: false })
            return
        }
        const accountId =
            this.props.accountMaster &&
            this.props.accountMaster.accountMaster &&
            this.props.accountMaster.accountMaster.id
        if (!accountId || this.mailchimpRequestAccountId === accountId) return
        this.mailchimpRequestAccountId = accountId
        if (this.state.hasMailchimp) this.setState({ hasMailchimp: false })
        axios
            .get('/accountMaster/hasMailchimp')
            .then((res) => {
                if (this.mailchimpRequestAccountId !== accountId) return
                this.setState({ hasMailchimp: Boolean(res.data && res.data.hasMailchimp) })
            })
            .catch(() => {
                if (this.mailchimpRequestAccountId !== accountId) return
                this.setState({ hasMailchimp: false })
            })
    }

    async getAccounts() {
        this.setState({ loadedAccounts: false })

        try {
            let accounts = await axios.get('/accountUser/me/accounts')
            this.setState({ accounts: accounts.data.Accounts, loadedAccounts: true })
        } catch (err) {
            this.setState({ accounts: [], loadedAccounts: true })
        }
    }

    navClicked() {
        this.setState(
            (prevState) => ({ navOpen: !prevState.navOpen }),
            () => {
                if (this.state.navOpen) {
                    this.getAccounts()
                }
            }
        )
    }

    goLog() {
        this.props.dispatch(user.logoutAndClear())
    }

    goNav(thePage) {
        this.props.history.push(thePage)
        this.setState({ navOpen: false })
    }

    goOpen(url) {
        window.open(url, '_blank')
        this.setState({ navOpen: false })
    }

    hasPermission(name, method) {
        return PermissionChecker(name, this.props.permissionStore.permissions, method)
    }

    handleCompanySwitcherMouseEnter() {
        clearTimeout(this.companySwitcherLeaveTimerRef.current)
        this.setState({ companySwitcherOpen: true })
    }

    handleCompanySwitcherMouseLeave() {
        this.companySwitcherLeaveTimerRef.current = setTimeout(() => {
            this.setState({ companySwitcherOpen: false })
        }, 300)
    }

    handleClickGetStarted() {
        this.props.dispatch(
            alterFullpage(
                <VideoModal
                    video='https://cdn1.ourmailsender.com/siteContent/videos/transpond-onboarding.mp4'
                    poster={onboardingPoster}
                    height={562}
                    width={1000}
                    onClose={() => this.props.dispatch(alterFullpage(null))}
                />
            )
        )
    }

    render() {
        var showBilling = true
        if (this.props.siteMaster.hidePricing) showBilling = false
        if (this.props.accountMaster.accountMaster.invoice) showBilling = false

        let canSwitchAccount = true
        if (this.props.siteMaster.blockSwitchAccount) canSwitchAccount = false

        const createdAt = moment(this.props.accountMaster.accountMaster.createdAt)
        const showMailchimpDate = createdAt >= moment('2026-10-30')

        const iconProps = { style: { height: 16, width: 16 }, color: '#969695' }
        const iconPropsEnd = { style: { height: 16, width: 16 }, color: '#999999' }

        return (
            <div className='pos-rel'>
                <button
                    type='button'
                    className='account-menu-button'
                    onClick={this.navClicked}
                    data-test='trigger-button'
                >
                    <span className='account-menu-button-name'>
                        {this.props.accountMaster.accountMaster.accountName}
                    </span>
                    <Avatar for='account' src={this.props.user.userData.profilePicFileName} />
                    <Icons color='#666666' icon='smallArrowDown' />
                </button>

                <DropDown isOpen={this.state.navOpen} onClose={() => this.setState({ navOpen: false })}>
                    <ul className='bb_account faux-list'>
                        {canSwitchAccount && (
                            <li
                                onMouseEnter={() => this.handleCompanySwitcherMouseEnter()}
                                onMouseLeave={() => this.handleCompanySwitcherMouseLeave()}
                            >
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavCompanySwitcher' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>Company Switcher</div>

                                <CompanySelect
                                    activeAccount={this.props.accountMaster.accountMaster}
                                    accounts={this.state.accounts}
                                    loadedAccounts={this.state.loadedAccounts}
                                    isOpen={this.state.companySwitcherOpen}
                                    onChangeAccount={this.props.onChangeAccount}
                                />
                            </li>
                        )}

                        {!this.props.siteMaster.readOnlyUsers && (
                            <li onClick={() => this.goNav('/cp/account/')}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavPreferences' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:myPreferences')}</div>
                            </li>
                        )}
                        {this.hasPermission('company', 'read') && (
                            <li onClick={() => this.goNav('/cp/company')}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavAccountSettings' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:accountSettings')}</div>
                            </li>
                        )}
                        {this.hasPermission('company', 'write') && showBilling && (
                            <li onClick={() => this.goNav('/cp/company/subscription')}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavBilling' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:billing')}</div>
                            </li>
                        )}

                        <hr className='light-hr' />

                        {this.props.siteMaster.siteId === 1 &&
                            this.hasPermission('company', 'write') &&
                            (this.state.hasMailchimp ||
                                isMailchimpImportBeta(this.props.accountMaster) ||
                                showMailchimpDate) && (
                                <li onClick={() => this.goNav('/cp/import')}>
                                    <div className={'uiTabSubIcon'}>
                                        <Icons icon='cloudDownload' {...iconProps} />
                                    </div>
                                    <div className='uiTabSubText'>{i18n.t('nav:import')}</div>
                                </li>
                            )}
                        {this.hasPermission('company', 'write') && (
                            <li onClick={() => this.goNav('/cp/company/integrations')}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavIntegrations' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:integrations')}</div>
                            </li>
                        )}
                        {this.hasPermission('company', 'write') && (
                            <li onClick={() => this.goNav('/cp/transactions')}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavTransactions' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:transactions')}</div>
                            </li>
                        )}
                        {this.props.siteMaster.siteId == 1 && this.props.user.userData.roleId === 1 && (
                            <li onClick={() => this.goNav('/cp/labs')}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavEarlyAccessFeatures' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:earlyAccessFeatures')}</div>
                            </li>
                        )}
                        {this.props.siteMaster.siteId == 1 && (
                            <li onClick={() => this.goNav('/cp/releases')}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavWhatsNew' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:whatsNew')}</div>
                            </li>
                        )}

                        <hr className='light-hr' />

                        <div className='uiTabDividerSubHeader'>Resources</div>

                        {this.props.siteMaster.siteId == 1 && (
                            <li data-ph='user-menu-get-started' onClick={() => this.goGetStarted()}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavGettingStarted' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:gettingStarted')}</div>
                            </li>
                        )}
                        {this.props.siteMaster.siteId == 1 && (
                            <li onClick={() => this.goNav('/cp/affiliate')}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavAds' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:affiliates')}</div>
                            </li>
                        )}
                        {this.props.siteMaster.siteId == 1 && (
                            <li onClick={() => this.goOpen('https://agency.mpzmail.com')}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavResell' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:resellTranspond')}</div>
                                <div className={'uiTabSubIconEnd'}>
                                    <Icons icon='externalBold' {...iconPropsEnd} />
                                </div>
                            </li>
                        )}
                        <li onClick={() => this.goOpen('/apidocs')}>
                            <div className={'uiTabSubIcon'}>
                                <Icons icon='mainNavApiDocs' {...iconProps} />
                            </div>
                            <div className='uiTabSubText'>{i18n.t('nav:apiDocs')}</div>
                            <div className={'uiTabSubIconEnd'}>
                                <Icons icon='externalBold' {...iconPropsEnd} />
                            </div>
                        </li>
                        {this.props.siteMaster.supportUrl && this.props.siteMaster.supportUrl.length && (
                            <li onClick={() => this.goOpen(this.props.siteMaster.supportUrl)}>
                                <div className={'uiTabSubIcon'}>
                                    <Icons icon='mainNavHelp' {...iconProps} />
                                </div>
                                <div className='uiTabSubText'>{i18n.t('nav:helpAndSupport')}</div>
                                <div className={'uiTabSubIconEnd'}>
                                    <Icons icon='externalBold' {...iconPropsEnd} />
                                </div>
                            </li>
                        )}

                        <hr className='light-hr' />

                        <li onClick={this.goLog}>
                            <div className={'uiTabSubIcon'}>
                                <Icons icon='mainNavLogout' {...iconProps} color='#CC4E32' />
                            </div>
                            <div className='uiTabSubText' style={{ color: '#CC4E32' }}>
                                {i18n.t('nav:logout')}
                            </div>
                        </li>
                    </ul>
                </DropDown>
            </div>
        )
    }
}
